import { trackHeapEvent } from '@app/adapters/heap'

import type { HeapProperties } from '@app/adapters/heap'

// Written by ReportsHelper#report_tracking_properties.
const TRACKING_SELECTOR = '[data-report-tracking]'

// Read from the DOM at fire time: the column editor's Pinia store raises events
// too, and has no route to the report's server-rendered properties.
export function reportTrackingProperties(): HeapProperties {
  const element = document.querySelector<HTMLElement>(TRACKING_SELECTOR)
  if (!element?.dataset.reportTracking) return {}

  return JSON.parse(element.dataset.reportTracking) as HeapProperties
}

// A caller firing on the way out has to pass properties it read while its own
// page was still the document; the default answers for whatever is there now.
export function trackReportEvent(
  name: string,
  properties: HeapProperties = {},
  report: HeapProperties = reportTrackingProperties()
): void {
  trackHeapEvent(name, { ...report, ...properties })
}
